const FBSvg = () => {
  return (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.5804 6H11.2835C8.36866 6 6 8.36253 6 11.2835V21.5865C6 24.5013 8.36253 26.87 11.2835 26.87H14.8242V19.4142H12.2101V16.4381H14.8242V14.1676C14.8242 11.5842 16.3644 10.1605 18.7147 10.1605C19.8438 10.1605 21.022 10.363 21.022 10.363V12.8973H19.7211C18.4385 12.8973 18.0397 13.6889 18.0397 14.5051V16.4381H20.8993L20.4452 19.4142H18.0458V26.87H21.5865C24.5013 26.87 26.87 24.5075 26.87 21.5865V11.2835C26.87 8.36866 24.5075 6 21.5865 6H21.5804Z" fill="white"/>
  </svg>
  )
}
export default FBSvg
